// extracted by mini-css-extract-plugin
export default {"form-check":"RelatedUsersModal_form-check__KmbCA","modal-header":"RelatedUsersModal_modal-header__i+y2Z"};